import { render, staticRenderFns } from "./ProjectFileCategoryFrame.vue?vue&type=template&id=01176f93&scoped=true&lang=pug&"
import script from "./ProjectFileCategoryFrame.vue?vue&type=script&lang=js&"
export * from "./ProjectFileCategoryFrame.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileCategoryFrame.vue?vue&type=style&index=0&id=01176f93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01176f93",
  null
  
)

export default component.exports